import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { PlaylistRoutes } from "./Constants/routes";


const Playlist = () => {
  const match = useRouteMatch();
  return (
    <>
       <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {PlaylistRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/playlist" />
      </Switch> 
     
    </>
  );
};

export default Playlist;
